import { Controller } from "@hotwired/stimulus";

export class DailySalesController extends Controller {
  static targets = ["halfModal", "selectLabel", "selectOption"];

  toggle() {
    this.halfModalTarget.classList.toggle("is-open");
  }

  handleChange() {
    const sortParam = this.selectLabelTarget.dataset.sortParam;
    const form = document.getElementById("daily-sales-form");
    const sortField = form.querySelector('input[name="sort"]');
    sortField.value = sortParam;
    form.requestSubmit();
  }

  select(event) {
    const selectedText = event.target.textContent.trim();
    const selectedElement = event.target.closest("li");
    const sortParam = selectedElement.dataset.sortParam;
    this.updateSelection(selectedText, selectedElement, sortParam);
    const form = document.getElementById("daily-sales-form");
    const sortField = form.querySelector('input[name="sort"]');
    sortField.value = sortParam;
    form.requestSubmit();
  }

  updateSelection(selectedText, selectedElement, sortParam) {
    this.selectLabelTarget.textContent = selectedText;
    this.selectLabelTarget.dataset.sortParam = sortParam;
    this.selectOptionTargets.forEach((option) => option.classList.remove("is-selected"));
    selectedElement.classList.add("is-selected");
    this.halfModalTarget.classList.remove("is-open");
  }
}
